module.exports = __webpack_public_path__ + "static/media/snappyBody.c26ee206.svg";